import { useStoreConfig } from '~/store/storeConfig'

type TTranslationOption = string | number | null | undefined
export type TTranslationOptions = { [x: string]: TTranslationOption }

export const useLang = () => {
  const storeConfig = useStoreConfig()
  const i18n = useI18n()
  const { isAlt, theme } = useTheme()

  const t = (key: string, opts: TTranslationOptions = {}, locale?: string): string => {
    let tKey = key

    if (isAlt) {
      tKey = `${theme}.${tKey}`
    }

    if (storeConfig.getAreKeysDisplayed && !opts.disablePreview) {
      return `(${tKey}): ${i18n.translate(tKey, opts)}`
    }

    const translation = i18n.translate(tKey, opts, locale)

    if (isAlt && !storeConfig.getAreKeysDisplayed && translation === tKey) {
      return translation.replace(`${theme}.`, '')
    }

    return translation
  }

  return {
    t,
  }
}
